import Drawer from "@mui/material/Drawer";
import CustomButton from "../../Button/CustomButton";
import styles from "./FInboxIntroModal.module.scss";

export default function FinboxIntroModal({ openFinboxModal, setOpenFinboxModal, finboxURL }) {
  return (
    <div className={styles.finboxIntroModal}>
      <Drawer anchor="bottom" open={openFinboxModal["bottom"]} onClose={() => setOpenFinboxModal({ ...openFinboxModal, bottom: false })}>
        <div className="exist__modal">
          <img src="/images/document-scan.png" alt="" />
          <h3>We need your bank statement to check your final eligibility</h3>
          <div>
            <CustomButton
              text="Continue"
              onClick={() => {
                window.location.href = finboxURL;
                setOpenFinboxModal({ ...openFinboxModal, bottom: false });
              }}
              floating={false}
            />
          </div>
        </div>
      </Drawer>
    </div>
  );
}
